import { Headers } from '@angular/http';

export const getContentHeaders = new Headers();
getContentHeaders.append('Accept', 'application/json');

export const postContentHeaders = new Headers();
postContentHeaders.append('Accept', 'application/json');
postContentHeaders.append('Content-Type', 'application/json');



// WEBPACK FOOTER //
// ./src/app/common/headers.ts